import { useStyles } from './styles'
import { TimeDisplay } from '@/shared/ui/timeDisplay'

export const StarterPackMainFrame = () => {
  const { classes } = useStyles()
  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <div className={classes.imageWrapper}>
          <img
            src="https://storage.yandexcloud.net/gamed/cases-and-rewards/default.webp"
            alt=""
            className={classes.packImage}
          />
          <div className={classes.discountContainer}>
            <span className={classes.discountText}>-35%</span>
          </div>
        </div>
        <div className={classes.textWrapper}>
          <span className={classes.offerTitle}>Special Offer!</span>
          <div className={classes.timeLeftWrapper}>
            <div className={classes.timeLeftContainer}>
              <div className={classes.daysWrapper}>
                <span>6 days</span>
              </div>
              <TimeDisplay timeLeft={{ hours: '20', minutes: '20', seconds: '20' }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
